import {
  SALARYSLIP_FETCHING,
  SALARYSLIP_FAILED,
  SALARYSLIP_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SALARYSLIP_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case SALARYSLIP_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case SALARYSLIP_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
